/* eslint-disable react/no-array-index-key */
import React, { FC } from 'react';

import { EvFlexRow, EvSkeleton } from '@evinced-private/ui-common';

import { TableHeaderRows } from 'src/common/components/skeletons/table-skeleton/TableHeaderRows';
import { TableRows } from 'src/common/components/skeletons/table-skeleton/TableRows';

import './TableSkeleton.scss';

interface TableSkeletonProps {
	columns: number;
	rowCount?: number;
	showActions?: boolean;
	rowHeight?: string;
}

export const TableSkeleton: FC<TableSkeletonProps> = ({
	columns,
	rowCount = 5,
	showActions = false,
	rowHeight = '70px'
}) => {
	const columnCount = columns;

	return (
		<div className="table-skeleton__wrapper">
			<div className="table-skeleton__top-row">
				<EvSkeleton width="180px" height="24px" />
				<EvFlexRow flex="1" />
				{showActions && <EvSkeleton width="300px" height="24px" />}
			</div>

			{/* Main table */}
			<table className="table-skeleton">
				<thead>
					<tr className="table-skeleton__header-row" style={{ height: '45px' }}>
						<TableHeaderRows
							count={columnCount}
							width="100%"
							height="24px"
							animationSpeed={0}
							keySet={Array.from({ length: columnCount }, (_, i) => `table_header_${i}`)}
						/>
					</tr>
				</thead>
				<tbody>
					<TableRows
						count={rowCount}
						columnCount={columnCount}
						height={rowHeight}
						animationSpeed={0}
						keySet={Array.from({ length: rowCount }, (_, i) => `table_row_${i}`)}
						columnKeySet={Array.from({ length: columnCount }, (_, i) => `table_column_${i}`)}
					/>
				</tbody>
			</table>
		</div>
	);
};
